import { Formik } from 'formik';
import {
  Grid,
  MenuItem,
  Button,
  Paper,
  TextField,
  Divider,
} from '@material-ui/core';
import { normalize, schema } from 'normalizr';
import { toTitleCase } from 'Utils';
import Error from 'Components/Error';
import Success from 'Components/Success';
import Loader from 'Components/Loader';
import Rating from 'Components/Rating';
import React from 'react';

import AddPhoto from './components/AddPhoto';
import AddSpecifications from './components/AddSpecifications';
import AddAttachment from './components/AddAttachment';
import API from './api';
import ContactDetails from './components/ContactDetails';
import Container from './components/Container';
import IESUpload from './components/IESUpload';
import IssuedBy from './components/IssuedBy';
import makeSchema from './validationSchema';
import NoteAndUrl from './components/NoteAndUrl';
import Correspondence from './components/Correspondence';
import PhotosAndNotes from './components/PhotosAndNotes';
import Section from './components/Section';
import UpdateSlipButton from './components/UpdateSlipButton';
import SettingsGrid from './components/SettingsGrid';
import SettingsItem from './components/SettingsItem';
import slipMachine from './stateMachine';
import TicketReference from './components/TicketReference';
import Quantities from './components/Quantities';
import ProjectDetails from './components/ProjectDetails';
import AddQuotation from './components/AddQuotation';
import DealSection from './components/DealSection';
import Snackbar from 'ServerErrorSnackbar';
import FieldError from './components/components/FieldError';
import CountryProject from './components/CountryProject';
import styled from 'styled-components';
import { rhythm } from 'Themes/typography';

import { Url } from './components/Url';
import axios from 'Axios';
import ErrorNotification from 'Components/ErrorNotification';
import SpecificationSheetForm from 'SpecificationSheetForm';

import withSpecSheet from 'SpecificationSheetForm/withSpecSheet';
import SelectCustom from '../../../../../components/demand/Demand/screens/CETicket/components/SelectCustom/index';

const TitleLeft = styled.h1`
  font-size: 1rem;
  float: left;
`;
const TitleRight = styled.h1`
  font-size: 1rem;
  float: right;
`;
const JobNo = styled.h1`
  font-size: 1rem;
  margin-bottom: ${rhythm(0.1)};
`;
const Clear = styled.div`
  clear: both;
`;
const PaperSheet = styled(Paper)`
  margin-top: ${rhythm(0.5)};
  padding: ${rhythm(0.1)} ${rhythm(0.8)} ${rhythm(0.5)} ${rhythm(0.8)};
  margin-bottom: ${rhythm(0.5)};
`;
const GridUrl = styled(Grid)``;

const SlipActionButton = styled(Button)`
  &&& {
    font-weight: 600;
  }
`;
const HeaderGrid = styled(Grid)`
  padding-bottom: ${rhythm(0.5)};
`;

const UpdateMsg = styled.div`
  color: #f44336;
  padding: ${rhythm(0.5)} 0;
  max-width: 1024px;
  text-align: justify;
  font-weight: 600;
  font-size: 1rem;
`;
class TicketView extends React.PureComponent {
  photo = React.createRef();
  photo1 = React.createRef();
  photo2 = React.createRef();
  luminaireImage = React.createRef();
  polarDiagramImage = React.createRef();
  dimensionsImage = React.createRef();
  specificationRef = React.createRef();
  attachmentRef = React.createRef();
  iesInputRef = React.createRef();
  errorRef = React.createRef();

  state = {
    photo: null,
    photo1: null,
    photo2: null,
    luminaireImage: null,
    polarDiagramImage: null,
    dimensionsImage: null,
    slip: null,
    viewState: slipMachine.initial,
    errors: null,
    criteria: null,
    showNotification: false,
    slipNotes: '',
    notesGeneral: '',
    validateSpecSheet: false,
    isSpecSheetValid: false,
    open: false,
    quotationAdded: false,
    locationOnPlan: '',
    projectName: '',
    projectCountry: '',
    snackBarMsg:
      'Error - not submitted. Please ensure you have completed all information on the Luminaire Specification Sheet and have uploaded budget pricing before issuing your response.',
    circularEconomy: [],
    menuQuestions: {},
    multipleQuestions: {},
    generatedTextField: false,
    generatedTextValues: {},
    multipleQuestionsId: [],
    textFieldValues: {},
    shortlistedCircularEconomy: [],
    shortlistedMenuQuestions: {},
    shortlistedMultipleQuestions: {},
    shortlistedGeneratedTextField: false,
    shortlistedGeneratedTextValues: {},
    shortlistedMultipleQuestionsId: [],
    shortlistedTextFieldValues: {},
  };

  resetState = () => {
    this.setState({
      photo: null,
      photo1: null,
      photo2: null,
      luminaireImage: null,
      polarDiagramImage: null,
      dimensionsImage: null,
      slip: null,
      viewState: slipMachine.initial,
      errors: null,
      criteria: null,
      showNotification: false,
      slipNotes: '',
      notesGeneral: '',
      validateSpecSheet: false,
      isSpecSheetValid: false,
      accessories: [],
    });
  };

  changeSlipStateBySupplier = () => {
    axios
      .put(
        'slip/' + this.props.match.params.slipId + '/supply/change_slip_state'
      )
      .then(
        response => {},
        error => {
          console.error(error);
        }
      );
  };

  componentDidMount() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.onGetSlip();
  }

  componentDidUpdate(prevProps, prevState) {
    // window.scrollTo({ top: 0, behavior: 'smooth' });
    if (prevProps.match.params.slipId !== this.props.match.params.slipId) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.onGetSlip();
    }
  }

  componentDidCatch(error, info) {
    this.setState({
      error,
    });
  }

  onGetSlip = () => {
    this.resetState();
    if (this.state.viewState !== 'loading') {
      return this.setState(
        (state, props) => ({
          ...state,
          viewState: slipMachine.initial,
        }),
        this.getSlip
      );
    }
    return this.getSlip();
  };

  getSlip = () => {
    const { slipId } = this.props.match.params;
    API.getCircularEconomy(slipId).then(res => {
      let questionsObject = {};
      let multipleObject = {};
      let textBoxValues = {};

      let generatedTextValuesLocal = {};
      let mappedQuestions = [];
      let mappedMultipleQuestions = [];
      let mappedAnswers = [];
      let mappedTextBoxQuestions = [];

      if (res.data !== []) {
        mappedQuestions = res.data.map(item =>
          item.questions
            .filter(question => question.questionType === 'PULL_DOWN_MENU')
            .map(question => question.id)
        );
        if (mappedQuestions) {
          let questions = [];
          questions = questions.concat.apply([], mappedQuestions);
          questionsObject = questions.reduce((acc, elem) => {
            acc[elem] = 9999;
            return acc;
          }, {});
        }

        mappedMultipleQuestions = res.data.map(item =>
          item.questions
            .filter(
              question => question.questionType === 'PULL_DOWN_MENU_MULTISELECT'
            )
            .map(question => question.id)
        );

        if (mappedMultipleQuestions) {
          let questions = [];
          questions = questions.concat.apply([], mappedMultipleQuestions);
          multipleObject = questions.reduce((acc, elem) => {
            acc[elem] = [];
            return acc;
          }, {});
        }

        mappedAnswers = res.data.map(item =>
          item.questions.map(question =>
            question.answers
              .filter(filter => filter.answerType === 'SELECT_TEXTBOX')
              .map(answer => answer.id)
          )
        );

        if (mappedAnswers) {
          let answers = [];
          answers = answers.concat.apply([], mappedAnswers);
          generatedTextValuesLocal = answers.reduce((acc, elem) => {
            acc[elem] = '';
            return acc;
          }, {});
        }

        mappedTextBoxQuestions = res.data.map(item =>
          item.questions
            .filter(question => question.questionType === 'DIRECT')
            .map(question => question.answers.map(answer => answer.id))
        );

        if (mappedTextBoxQuestions) {
          let answers = [];
          let slicedAnswers = [];
          answers = answers.concat.apply([], mappedTextBoxQuestions);
          for (let i = 0; i < answers.length; i++) {
            for (let j = 0; j < answers[i].length; j++) {
              slicedAnswers.push([answers[i][j]]);
            }
          }
          textBoxValues = slicedAnswers.reduce((acc, elem) => {
            acc[elem] = '';
            return acc;
          }, {});
        }
        this.setState({
          circularEconomy: res.data,
          menuQuestions: { ...questionsObject },
          multipleQuestions: { ...multipleObject },
          generatedTextValues: { ...generatedTextValuesLocal },
          textFieldValues: { ...textBoxValues },
        });
      }
      if (this.props.location.state && this.props.location.state.shortlisted) {
        API.getShortlistedSlip(slipId)
          .then(res => {
            API.getCircularEconomyShortlisted(slipId).then(response => {
              this.setState({
                shortlistedCircularEconomy: [...response.data],
              });
            });

            const { criteria, ...rest } = res.data;
            const normalized = this.normalizeData(criteria);

            const existingSpecSheet = rest.specificationSheet;
            const manufacturer = rest.supplierContact.manufacturer;

            this.props.setInitialSpecSheet(existingSpecSheet, manufacturer);

            this.setState(
              prevState => {
                return {
                  ...prevState,
                  photo: rest.image1Id,
                  photo1: rest.image2Id,
                  photo2: rest.image3Id,
                  luminaireImage: rest.luminaireImage,
                  polarDiagramImage: rest.polarDiagramImage,
                  dimensionsImage: rest.dimensionsImage,
                  slip: rest,
                  criteria: {
                    ...rest,
                    ...normalized,
                  },
                  slipState: rest.slipState,
                  viewState: slipMachine.transition(prevState.viewState, 'SLIP')
                    .value,
                  slipNotes: rest.slipNote,
                  generalNotes: rest.generalNotes,
                  locationOnPlan: rest.locationOnPlan,
                  projectName: rest.projectName && rest.projectName,
                  projectCountry: rest.projectCountry && rest.projectCountry,
                  quotationAdded: rest.quotation ? true : false,
                  accessories: res.data.specificationSheet['accessories'],
                };
              },
              () => {
                this.changeSlipStateBySupplier();
              }
            );
          })
          .catch(err => {
            this.setState(prevState => ({
              ...prevState,
              errors: err,
              viewState: slipMachine.transition(prevState.viewState, 'ERROR')
                .value,
            }));
          });
      } else {
        API.getSlip(slipId)
          .then(res => {
            API.getCircularEconomyShortlisted(slipId).then(response => {
              this.setState({
                shortlistedCircularEconomy: [...response.data],
              });
            });
            const { criteria, ...rest } = res.data;
            const normalized = this.normalizeData(criteria);

            const existingSpecSheet = rest.specificationSheet;
            const manufacturer = rest.supplierContact.manufacturer;

            let localMenuQuestions = {};
            let localMultipleQuestions = {};
            let localGeneratedTextValues = {};
            let localTextFieldValues = {};

            let multiSelectIds = [];

            if (res.data.answers) {
              const pullDownAnswerIds = res.data.answers
                .filter(answer => answer.questionType === 'PULL_DOWN_MENU')
                .sort((a, b) => a.questionId - b.questionId)
                .map(answer => answer.answerId);

              const multiSelectAnswers = res.data.answers
                .filter(
                  answer => answer.questionType === 'PULL_DOWN_MENU_MULTISELECT'
                )
                .map(answer => answer.answerText);

              multiSelectIds = res.data.answers
                .filter(
                  answer => answer.questionType === 'PULL_DOWN_MENU_MULTISELECT'
                )
                .map(answer => answer.answerId.toString());

              const generatedText = res.data.answers
                .filter(
                  answer => answer.questionType === 'PULL_DOWN_MENU_MULTISELECT'
                )
                .filter(answer => answer.value !== null)
                .map(answer => answer.value);

              const textFieldValueAnswers = res.data.answers
                .filter(answer => answer.questionType === 'DIRECT')
                .map(answer => answer.value);

              for (
                let i = 0;
                i < Object.values(this.state.menuQuestions).length;
                i++
              ) {
                localMenuQuestions[
                  Object.entries(this.state.menuQuestions)[i][0]
                ] = pullDownAnswerIds[i];
              }
              for (let i = 0; i < multiSelectAnswers.length; i++) {
                localMultipleQuestions[7] = multiSelectAnswers.map(
                  answer => answer
                );
              }
              for (
                let i = 0;
                i < Object.values(this.state.generatedTextValues).length;
                i++
              ) {
                localGeneratedTextValues[
                  Object.entries(this.state.generatedTextValues)[i][0]
                ] = [generatedText[0]];
              }

              for (
                let i = 0;
                i < Object.values(this.state.textFieldValues).length;
                i++
              ) {
                localTextFieldValues[
                  Object.entries(this.state.textFieldValues)[i][0]
                ] = [textFieldValueAnswers[i]];
              }
              if (multiSelectAnswers.includes('Yes, other - please enter:')) {
                this.setState({
                  generatedTextField: true,
                });
              }
            }

            this.props.setInitialSpecSheet(existingSpecSheet, manufacturer);
            this.setState(
              prevState => {
                return {
                  ...prevState,
                  photo: rest.image1Id,
                  photo1: rest.image2Id,
                  photo2: rest.image3Id,
                  luminaireImage: rest.luminaireImage,
                  polarDiagramImage: rest.polarDiagramImage,
                  dimensionsImage: rest.dimensionsImage,
                  slip: rest,
                  criteria: {
                    ...rest,
                    ...normalized,
                  },
                  viewState: slipMachine.transition(prevState.viewState, 'SLIP')
                    .value,
                  slipNotes: rest.slipNote,
                  locationOnPlan: rest.locationOnPlan && rest.locationOnPlan,
                  projectName: rest.projectName && rest.projectName,
                  projectCountry: rest.projectCountry && rest.projectCountry,
                  menuQuestions: { ...localMenuQuestions },
                  multipleQuestions: { ...localMultipleQuestions },
                  multipleQuestionsId: [...multiSelectIds],
                  generatedTextValues: { ...localGeneratedTextValues },
                  textFieldValues: { ...localTextFieldValues },
                  accessories: res.data.specificationSheet['accessories'],
                };
              },
              () => {
                this.changeSlipStateBySupplier();
              }
            );
          })
          .catch(err => {
            this.setState(prevState => ({
              ...prevState,
              errors: err,
              viewState: slipMachine.transition(prevState.viewState, 'ERROR')
                .value,
            }));
          });
      }
    });
  };

  normalizeData = data => {
    const node = new schema.Entity('criteria');
    node.define({
      criteria: [node],
    });
    const treeSchema = [node];

    const normalized = normalize(data, treeSchema);

    return {
      entities: normalized.entities.criteria,
      result: normalized.result,
    };
  };

  handleItemName = name => {
    const nameWords = name.split(' ');
    if (nameWords.length === 1) {
      return name;
    }
    return nameWords
      .map((word, i) => {
        if (i === 0) return word;
        return toTitleCase(word);
      })
      .join('');
  };

  onUrlAndNoteChange = setFieldValue => type => e => {
    setFieldValue(type, e.target.value);
  };

  onAddGeneralNote = setFieldValue => type => e => {
    setFieldValue(type, e.target.value);
  };

  onAddPhoto = setFieldValue => e => {
    const inputName = e.target.getAttribute('name');
    if (this[inputName].current.files && this[inputName].current.files[0]) {
      if (this[inputName].current.files[0].size > 5242880) {
        this[inputName].current.value = '';
        return this.setState(state => {
          return {
            ...state,
            viewState: slipMachine.transition(
              state.viewState,
              'PHOTO_SIZE_ERROR'
            ).value,
          };
        });
      }
      const reader = new FileReader();
      reader.onload = e => {
        this.setState(prevState => {
          return {
            ...prevState,
            [inputName]: e.target.result,
          };
        }, setFieldValue(inputName, this[inputName].current.files[0]));
      };
      reader.readAsDataURL(this[inputName].current.files[0]);
    }
  };

  onClearImage = setFieldValue => photo => () => {
    this.setState(
      {
        [photo]: null,
      },
      setFieldValue(photo, null)
    );
  };

  onAddSpecification = (setFieldValue, values) => attach => () => {
    if (
      this.specificationRef.current.files &&
      this.specificationRef.current.files[0]
    ) {
      if (this.specificationRef.current.files[0].size > 5242880) {
        this.specificationRef.current.value = '';
        return this.setState(state => {
          return {
            ...state,
            viewState: slipMachine.transition(
              state.viewState,
              'SPEC_SIZE_ERROR'
            ).value,
          };
        });
      }

      setFieldValue(attach, this.specificationRef.current.files[0]);
    }
  };

  onAddAttachment = (setFieldValue, values) => attach => () => {
    if (
      this.attachmentRef.current.files &&
      this.attachmentRef.current.files[0]
    ) {
      if (this.attachmentRef.current.files[0].size > 5242880) {
        this.attachmentRef.current.value = '';
        return this.setState(state => {
          return {
            ...state,
            viewState: slipMachine.transition(
              state.viewState,
              'ATTACH_SIZE_ERROR'
            ).value,
          };
        });
      }
      setFieldValue(attach, this.attachmentRef.current.files[0]);
    }
  };

  onClearValue = (setFieldValue, clearIES = false) => type => () => {
    setFieldValue(type, null);
    if (clearIES) {
      this.iesInputRef.current.value = '';
    }
  };

  onSpecificationRemove = (setFieldValue, values) => index => () => {
    setFieldValue(`file${index}`, null);
    this.specificationRef.current.value = '';
  };

  onAttachmentRemove = (setFieldValue, values) => index => () => {
    setFieldValue(`attachmentFile${index}`, null);
    this.attachmentRef.current.value = '';
  };

  onAddIESFile = setFieldValue => () => {
    if (this.iesInputRef.current.files && this.iesInputRef.current.files[0]) {
      if (this.iesInputRef.current.files[0].size > 5242880) {
        this.iesInputRef.current.value = '';
        return this.setState(state => {
          return {
            ...state,
            viewState: slipMachine.transition(state.viewState, 'IES_SIZE_ERROR')
              .value,
          };
        });
      }
      setFieldValue('ies', this.iesInputRef.current.files[0]);
    }
  };
  onAddQuotation = setFieldValue => e => {
    this.setState({ quotationAdded: true });
    if (e.currentTarget.files[0]) {
      setFieldValue('quotation', e.currentTarget.files[0]);
    }
  };

  onErrorCancel = () => {
    this.setState(prevState => ({
      errors: null,
      viewState: slipMachine.transition(prevState.viewState, 'CANCEL').value,
    }));
  };

  handleQuestions = (event, id, type, answerType, answerId) => {
    let localMultipleQuestionsId = [...this.state.multipleQuestionsId];
    if (type === 'singleSelect') {
      this.setState(prevState => ({
        menuQuestions: {
          ...prevState.menuQuestions,
          [id]: event.target.value,
        },
      }));
    }
    if (type === 'multipleSelect') {
      if (answerType === 'SELECT_TEXTBOX') {
        this.generateTextField(answerType, answerId);
      }

      if (localMultipleQuestionsId.includes(answerId)) {
        for (let i = 0; i < localMultipleQuestionsId.length; i++) {
          if (localMultipleQuestionsId[i] === answerId) {
            localMultipleQuestionsId.splice(i, 1);
          }

          this.setState(prevState => ({
            multipleQuestions: {
              ...prevState.multipleQuestions,
              [id]: event.target.value,
            },
            multipleQuestionsId: [...localMultipleQuestionsId],
          }));
        }
      } else {
        const localEventTarget = event.target.value;
        if (this.state.multipleQuestions[id].includes('Not Set')) {
          this.state.multipleQuestions[id].shift();
          this.state.multipleQuestionsId.shift();
        }
        if (localEventTarget.includes('Not Set')) {
          localEventTarget.shift();
        }
        this.setState(prevState => ({
          multipleQuestions: {
            ...prevState.multipleQuestions,
            [id]: localEventTarget,
          },
          multipleQuestionsId: [...prevState.multipleQuestionsId, answerId],
        }));
      }
    }
  };

  generateTextField = (type, id) => {
    this.setState({
      generatedTextField: !this.state.generatedTextField,
    });
  };

  handleGeneratedTextField = (event, id) => {
    const value = event.target.value;
    this.setState({
      generatedTextValues: {
        [id]: value,
      },
    });
  };

  handleTextField = (event, id) => {
    const value = event.target.value;
    this.setState(prevState => ({
      textFieldValues: {
        ...prevState.textFieldValues,
        [id]: value,
      },
    }));
  };

  onRetry = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        viewState: slipMachine.initial,
      };
    }, this.getTicket);
  };

  removeWhiteSpace(string) {
    return string.replace(/ /, '');
  }

  makeInitialValues = data => {
    if (!data) return;
    let initialState;
    initialState = {
      photo: data.image1Id,
      photo1: data.image2Id,
      photo2: data.image3Id,

      attachmentFile1: data.attachmentFile1,
      attachmentFile2: data.attachmentFile2,
      attachmentFile3: data.attachmentFile3,
      attachmentFile4: data.attachmentFile4,
      attachmentFile5: data.attachmentFile5,
      attachmentFile6: data.attachmentFile6,
      attachmentFile7: data.attachmentFile7,

      file1: data.file1,
      file2: data.file2,
      file3: data.file3,

      url: data.url ? data.url : '',
      slipNote: data.slipNote ? data.slipNote : '',
      ies: data.ies,
    };

    // if (this.props.location.state && this.props.location.state.shortlisted) {
    if (this.state.slip.shortlisted) {
      initialState = {
        ...initialState,

        luminaireImage: data.luminaireImage,
        polarDiagramImage: data.polarDiagramImage,
        dimensionsImage: data.dimensionsImage,
        quotation: data.quotation ? data.quotation : null,
        criteriaValues: {},
        generalNotes: data.generalNotes ? data.generalNotes : '',
      };
    }

    const { result, entities } = data;

    for (let prop in result) {
      for (let criteria in entities[result[prop]].criteria) {
        const currCriteria =
          entities[entities[result[prop]].criteria[criteria]];
        const name = this.removeWhiteSpace(
          `${entities[result[prop]].name}_${currCriteria.name}`
        );
        if (this.state.slip.shortlisted) {
          // if (
          //   this.props.location.state &&
          //   this.props.location.state.shortlisted
          // ) {
          if (currCriteria.value !== null) {
            initialState.criteriaValues[currCriteria.id] = currCriteria.value;
          } else {
            initialState.criteriaValues[currCriteria.id] = '';
          }
        }
        initialState[name] = true;
      }
    }
    initialState.slipNote = '';
    return initialState;
  };

  renderDesc(criteria) {
    if (!criteria || !criteria.length) return '';
    return criteria.map(id => {
      const { name, value, unit } = this.state.criteria.entities[id];
      if (name && !value) {
        return `${name} `;
      }
      if (name && value) {
        if (
          id === 132 ||
          id === 389 ||
          id === 270 ||
          id === 318 ||
          id === 319 ||
          id === 320 ||
          id === 321 ||
          id === 322 ||
          id === 323 ||
          id === 324 ||
          id === 325 ||
          id === 391 ||
          id === 330 ||
          id === 1304 ||
          id === 261
        ) {
          if (unit === null) {
            return `${value}`;
          } else {
            return `${value}${unit !== null ? ' ' + unit : ''} `;
          }
        } else {
          if (id === 326 || id === 327 || id === 329) {
            return `${name} ${value}${unit !== null ? ' ' + unit : ''} `;
          } else if (
            id === 63 ||
            id === 111 ||
            id === 261 ||
            id === 328 ||
            id === 65
          ) {
            return `${name} ${value}${unit !== null ? ' ' + unit : ''} `;
          } else if (id === 376 || id === 331) {
            return `${value}${unit !== null ? ' ' + unit : ''} `;
          } else if (id === 568) {
            return name + value + unit;
          } else {
            return `${name} ${value}${unit !== null ? ' ' + unit : ''} `;
          }
        }
      }
      return '';
    });
  }

  renderCriteria = (handleChange, handleBlur, values, errors, touched) => {
    if (!this.state.criteria || !values) return null;
    return this.state.criteria.result.map(id => {
      const name = this.state.criteria.entities[id].name;
      return (
        <Section
          shortlisted={
            // this.props.location.state && this.props.location.state.shortlisted
            this.state.slip && this.state.slip.shortlisted
          }
          key={id}
          name={toTitleCase(name)}
        >
          <SettingsGrid>
            {this.state.criteria.entities[id].criteria.map(criteriaId => {
              const nameAtr = this.removeWhiteSpace(
                `${this.state.criteria.entities[id].name}_${this.state.criteria.entities[criteriaId].name}`
              );
              return (
                <SettingsItem
                  shortlisted={
                    // this.props.location.state &&
                    // this.props.location.state.shortlisted
                    this.state.slip && this.state.slip.shortlisted
                  }
                  checked
                  preview
                  key={criteriaId}
                  criteriaId={criteriaId}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name={nameAtr}
                  value={'checked'}
                  inputValue={
                    values.criteriaValues && values.criteriaValues[criteriaId]
                      ? values.criteriaValues[criteriaId]
                      : ''
                  }
                  title={this.state.criteria.entities[criteriaId].name}
                  desc={this.renderDesc(
                    this.state.criteria.entities[criteriaId].criteria
                  )}
                />
              );
            })}
          </SettingsGrid>
        </Section>
      );
    });
  };

  renderSpecificationSheet = () => (
    <Section>
      <div>
        <TitleLeft>
          Project Title:
          {this.state.slip.projectDetails &&
            ' ' + this.state.slip.projectDetails.name}
        </TitleLeft>
        <TitleRight>Luminaire Specification Sheet</TitleRight>
      </div>
      <Clear> </Clear>
      <JobNo>
        Job No.:
        {this.state.slip.projectDetails &&
          ' ' + this.state.slip.projectDetails.uniqueProjectNumber}
      </JobNo>
      <div className="spacer-2" />
      {/* <SettingsGrid height="362px" direction="column"> */}

      <FieldError innerRef={this.errorRef}>
        {!this.state.isSpecSheetValid &&
          this.state.validateSpecSheet &&
          '*Please ensure you have entered all luminaire specification information below '}
      </FieldError>
      <SpecificationSheetForm
        specSheet={this.props.specificationSheet}
        handleSelectChange={this.props.handleSelectChange}
        handleInputChange={this.props.handleInputChange}
        accessories={this.state.accessories}
        leftSide={[
          'manufacturer',
          'productRange',
          'luminaireType',
          'mounting',
          'finish',
          'accessories',
          'protectionRating',
          'protectionRatingIk',
          'opticalDistribution',
          'luminaireLifetime',
          'l',
          'b',
          'lightSourceType',
        ]}
        rightSide={[
          'mountingPosition',
          'lightSourceColour',
          'colourRendering',
          'maxColourVariation',
          'ratedLuminousFlux',
          'inputPower',
          'efficacy',
          'driverLocation',
          'dimmable',
          'dimmingType',
          'emergencyLighting',
          'emergencyType',
        ]}
        paperstyle="false"
        isDisabled={this.state.slip.slipState === 'DISCARDED' ? true : false}
      />
      {/* </SettingsGrid> */}
      <div className="spacer-2" />
    </Section>
  );

  editSlip = (slipId, data) => () => {
    API.editSlip(slipId, data)
      .then(res => {
        if (res.status === 200) {
          this.setState(
            prevState => {
              return {
                ...prevState,
                viewState: slipMachine.transition(prevState.viewState, 'EDITED')
                  .value,
                showNotification: true,
              };
            },
            () => {
              this.props.history.push({
                pathname: '/supply',
                state: { slipUpdated: true },
              });
            }
          );
        }
      })
      .catch(err => {
        this.setState(prevState => ({
          ...prevState,
          errors: err,
          viewState: slipMachine.transition(prevState.viewState, 'ERROR').value,
        }));
      });
  };

  validateSpecificationSheet = data => {
    let valid = true;
    Object.keys(data.specificationSheet).forEach(key => {
      switch (key) {
        case 'productRange':
          if (data.specificationSheet[key] === '') {
            valid = false;
          }
          break;
        case 'b':
          if (!data.specificationSheet[key].value) {
            valid = false;
          }
          break;
        case 'l':
          if (!data.specificationSheet[key].value) {
            valid = false;
          }
          break;
        case 'luminaireLifetime':
          if (!data.specificationSheet[key].value) {
            valid = false;
          }
          break;
        case 'ratedLuminousFlux':
          if (!data.specificationSheet[key].value) {
            valid = false;
          }
          break;
        case 'inputPower':
          if (!data.specificationSheet[key].value) {
            valid = false;
          }
          break;
        case 'colourRendering':
          if (
            data.specificationSheet[key].criteriaId === 318 &&
            !data.specificationSheet[key].value
          ) {
            valid = false;
          } else if (!data.specificationSheet[key].criteriaId) {
            valid = false;
          }
          break;
        case 'finish':
          if (
            (data.specificationSheet[key].criteriaId === 65 ||
              data.specificationSheet[key].criteriaId === 64) &&
            !data.specificationSheet[key].value
          ) {
            valid = false;
          } else if (!data.specificationSheet[key].criteriaId) {
            valid = false;
          }
          break;
        case 'accessories':
          if (Array.isArray(data.specificationSheet[key])) {
            if (
              data.specificationSheet[key].find(item => item.criteriaId === 550)
            ) {
              if (
                !data.specificationSheet[key].find(
                  item => item.criteriaId === 550
                ).value
              )
                valid = false;
            }
            if (
              data.specificationSheet[key].find(item => item.criteriaId === 551)
            ) {
              if (
                !data.specificationSheet[key].find(
                  item => item.criteriaId === 551
                ).value
              )
                valid = false;
            }
          }
          break;
        default:
          if (!data.specificationSheet[key].criteriaId) {
            valid = false;
          }
      }
    });
    return valid;
  };

  onSpecificationFormSave = values => {
    const formData = new FormData();
    if (
      values.quotation &&
      typeof values.quotation.assetId !== 'string' &&
      values.quotation.assetId !== null
    ) {
      formData.append('quotation', values.quotation);
    }

    if (
      typeof values.luminaireImage !== 'string' &&
      values.luminaireImage !== null
    ) {
      formData.append('luminaireImage', values.luminaireImage);
    } else if (
      typeof values.luminaireImage === 'string' &&
      values.luminaireImage !== null
    ) {
      formData.append('luminaireImageId', values.luminaireImage);
    } else formData.append('luminaireImageId', '');

    if (
      typeof values.polarDiagramImage !== 'string' &&
      values.polarDiagramImage !== null
    ) {
      formData.append('polarDiagramImage', values.polarDiagramImage);
    } else if (
      typeof values.polarDiagramImage === 'string' &&
      values.polarDiagramImage !== null
    ) {
      formData.append('polarDiagramImageId', values.polarDiagramImage);
    } else formData.append('polarDiagramImageId', '');

    if (
      typeof values.dimensionsImage !== 'string' &&
      values.dimensionsImage !== null
    ) {
      formData.append('dimensionsImage', values.dimensionsImage);
    } else if (
      typeof values.dimensionsImage === 'string' &&
      values.dimensionsImage !== null
    ) {
      formData.append('dimensionsImageId', values.dimensionsImage);
    } else formData.append('dimensionsImageId', '');
    let i;
    for (i = 1; i < 8; i++) {
      if (
        values[`attachmentFile${i}`] &&
        !values[`attachmentFile${i}`].assetId
      ) {
        formData.append(`attachmentFile${i}`, values[`attachmentFile${i}`]);
      } else if (
        values[`attachmentFile${i}`] &&
        values[`attachmentFile${i}`].assetId
      ) {
        formData.append(
          `attachmentFile${i}Id`,
          values[`attachmentFile${i}`].assetId
        );
      } else {
        formData.append(`attachmentFile${i}Id`, '');
      }
    }

    let y;
    for (y = 1; y < 4; y++) {
      if (values[`file${y}`] && !values[`file${y}`].assetId) {
        formData.append(`file${y}`, values[`file${y}`]);
      } else if (values[`file${y}`] && values[`file${y}`].assetId) {
        formData.append(`file${y}Id`, values[`file${y}`].assetId);
      } else {
        formData.append(`file${y}Id`, '');
      }
    }

    if (values.ies === null) {
      formData.append('iesId', '');
    } else if (!values.ies.assetId) {
      formData.append('ies', values.ies);
    } else {
      formData.append('iesId', values.ies.assetId);
    }

    const specificationSheet = {};

    Object.entries(this.props.specificationSheet).forEach(([key, value]) => {
      if (key === 'productRange') {
        specificationSheet[key] = value.criteriaStringForBe;
      } else if (key === 'manufacturer') {
        return;
      } else if (key === 'protectionRating') {
        if (value.criteriaIdForBe !== 99999) {
          specificationSheet[key] = {
            criteriaId: value.criteriaIdForBe,
            // unit: value.unit || null,
            value: value.criteriaStringForBe,
          };
        } else {
          specificationSheet[key] = {
            criteriaId: null,
            // unit: null,
            value: null,
          };
        }
      } else if (key === 'protectionRatingIk') {
        if (value.criteriaIdForBe !== 99999) {
          specificationSheet[key] = {
            criteriaId: value.criteriaIdForBe,
            // unit: value.unit || null,
            value: value.criteriaStringForBe,
          };
        } else {
          specificationSheet[key] = {
            criteriaId: null,
            // unit: null,
            value: null,
          };
        }
      } else if (key === 'accessories') {
        if (!value.criteriaIdForBe.find(val => val.value === 99999)) {
          let help = [];
          value.criteriaIdForBe.forEach((item, index) => {
            help.push({
              criteriaId: item.value,
              value: item.stringValue
                ? item.stringValue
                : item.value === 550 || item.value === 551
                ? value.criteriaStringForBe
                : null,
            });
          });
          specificationSheet[key] = help;
        } else {
          specificationSheet[key] = null;
        }
      } else if (value.criteriaIdForBe === 99999) {
        if (value.criteriaStringForBe !== '') {
          specificationSheet[key] = {
            criteriaId: value.id,
            unit: value.unit || null,
            value: value.criteriaStringForBe,
          };
        } else {
          specificationSheet[key] = {
            criteriaId: null,
            unit: null,
            value: null,
          };
        }
      } else if (value.criteriaStringForBe !== 9999) {
        if (value.criteriaStringForBe === '') {
          specificationSheet[key] = {
            criteriaId: value.criteriaIdForBe,
            unit: value.unit || null,
            value: null,
          };
        } else {
          specificationSheet[key] = {
            criteriaId: value.criteriaIdForBe,
            unit: value.unit || null,
            value: value.criteriaStringForBe,
          };
        }
      } else {
        specificationSheet[key] = null;
      }
    });

    // delete specificationSheet.manufacturer;
    delete specificationSheet.efficacy;

    const data = {
      slipNote: btoa(encodeURI(values.slipNote)),
      generalNotes: values.generalNotes,
      specificationSheet,
    };
    if (this.state.slip.drafted) {
      if (this.state.validateSpecSheet) {
        let isValid = this.validateSpecificationSheet(data);
        if (isValid) {
          this.setState(
            prevState => ({
              ...prevState,
              viewState: slipMachine.transition(
                prevState.viewState,
                'EDIT_SLIP'
              ).value,
              open: false,
            }),
            async () => {
              try {
                const saveRes = await API.saveSpecificationUnDraft(
                  this.props.match.params.slipId,
                  data
                );
                if (saveRes.status === 200) {
                  const addQuotationRes = await API.addQuotation(
                    this.props.match.params.slipId,
                    formData
                  );
                  this.setState(
                    prevState => {
                      return {
                        ...prevState,
                        viewState: slipMachine.transition(
                          prevState.viewState,
                          'EDITED'
                        ).value,
                        showNotification: true,
                      };
                    },
                    () => {
                      this.props.history.push({
                        pathname: '/supply',
                        state: { slipUpdated: true },
                      });
                    }
                  );
                }
              } catch (err) {
                this.setState(prevState => ({
                  ...prevState,
                  errors: err,
                  viewState: slipMachine.transition(
                    prevState.viewState,
                    'ERROR'
                  ).value,
                }));
              }
            }
          );
        } else {
          window.scrollTo({
            top: this.errorRef.current.offsetTop,
            left: 0,
            behavior: 'smooth',
          });
          this.setState({
            isSpecSheetValid: false,
            open: !this.state.slip.shortlisted ? true : false,
          });
        }
      } else {
        this.setState(
          prevState => ({
            ...prevState,
            viewState: slipMachine.transition(prevState.viewState, 'EDIT_SLIP')
              .value,
          }),
          async () => {
            try {
              const saveRes = await API.saveSpecification(
                this.props.match.params.slipId,
                data
              );
              if (saveRes.status === 200) {
                const addQuotationRes = await API.addQuotation(
                  this.props.match.params.slipId,
                  formData
                );
                this.setState(
                  prevState => {
                    return {
                      ...prevState,
                      viewState: slipMachine.transition(
                        prevState.viewState,
                        'EDITED'
                      ).value,
                      showNotification: true,
                    };
                  },
                  () => {
                    this.props.history.push({
                      pathname: '/supply',
                      state: { slipUpdated: true },
                    });
                  }
                );
              }
            } catch (err) {
              this.setState(prevState => ({
                ...prevState,
                errors: err,
                viewState: slipMachine.transition(prevState.viewState, 'ERROR')
                  .value,
              }));
            }
          }
        );
      }
    } else {
      if (this.state.validateSpecSheet) {
        let isValid = this.validateSpecificationSheet(data);
        if (isValid) {
          this.setState(
            prevState => ({
              ...prevState,
              viewState: slipMachine.transition(
                prevState.viewState,
                'EDIT_SLIP'
              ).value,
              open: false,
            }),
            async () => {
              try {
                const saveRes = await API.saveSpecification(
                  this.props.match.params.slipId,
                  data
                );
                if (saveRes.status === 200) {
                  const addQuotationRes = await API.addQuotation(
                    this.props.match.params.slipId,
                    formData
                  );
                  this.setState(
                    prevState => {
                      return {
                        ...prevState,
                        viewState: slipMachine.transition(
                          prevState.viewState,
                          'EDITED'
                        ).value,
                        showNotification: true,
                      };
                    },
                    () => {
                      this.props.history.push({
                        pathname: '/supply',
                        state: { slipUpdated: true },
                      });
                    }
                  );
                }
              } catch (err) {
                this.setState(prevState => ({
                  ...prevState,
                  errors: err,
                  viewState: slipMachine.transition(
                    prevState.viewState,
                    'ERROR'
                  ).value,
                }));
              }
            }
          );
        } else {
          window.scrollTo({
            top: this.errorRef.current.offsetTop,
            left: 0,
            behavior: 'smooth',
          });
          this.setState({
            open: !this.state.slip.shortlisted ? true : false,
            isSpecSheetValid: false,
          });
        }
      } else {
        this.setState(
          prevState => ({
            ...prevState,
            viewState: slipMachine.transition(prevState.viewState, 'EDIT_SLIP')
              .value,
          }),
          async () => {
            try {
              const saveRes = await API.saveSpecificationDraft(
                this.props.match.params.slipId,
                data
              );
              if (saveRes.status === 200) {
                const addQuotationRes = await API.addQuotation(
                  this.props.match.params.slipId,
                  formData
                );
                this.setState(
                  prevState => {
                    return {
                      ...prevState,
                      viewState: slipMachine.transition(
                        prevState.viewState,
                        'EDITED'
                      ).value,
                      showNotification: true,
                    };
                  },
                  () => {
                    this.props.history.push({
                      pathname: '/supply',
                      state: { slipUpdated: true },
                    });
                  }
                );
              }
            } catch (err) {
              this.setState(prevState => ({
                ...prevState,
                errors: err,
                viewState: slipMachine.transition(prevState.viewState, 'ERROR')
                  .value,
              }));
            }
          }
        );
      }
    }
  };

  onEditSlip = values => {
    const data = new FormData();
    const { slipId } = this.props.match.params;

    let url = btoa(encodeURI(values.url));
    let note = btoa(encodeURI(values.slipNote));
    data.append('url', url);
    if (typeof values.photo !== 'string' && values.photo !== null) {
      data.append('image1', values.photo);
    } else if (typeof values.photo === 'string' && values.photo !== null) {
      data.append('image1Id', values.photo);
    } else data.append('image1Id', '');

    if (typeof values.photo1 !== 'string' && values.photo1 !== null) {
      data.append('image2', values.photo1);
    } else if (typeof values.photo1 === 'string' && values.photo1 !== null) {
      data.append('image2Id', values.photo1);
    } else data.append('image2Id', '');

    if (typeof values.photo2 !== 'string' && values.photo2 !== null) {
      data.append('image3', values.photo2);
    } else if (typeof values.photo2 === 'string' && values.photo2 !== null) {
      data.append('image3Id', values.photo2);
    } else data.append('image3Id', '');

    let i;
    for (i = 1; i < 8; i++) {
      if (
        values[`attachmentFile${i}`] &&
        !values[`attachmentFile${i}`].assetId
      ) {
        data.append(`attachmentFile${i}`, values[`attachmentFile${i}`]);
      } else if (
        values[`attachmentFile${i}`] &&
        values[`attachmentFile${i}`].assetId
      ) {
        data.append(
          `attachmentFile${i}Id`,
          values[`attachmentFile${i}`].assetId
        );
      } else {
        data.append(`attachmentFile${i}Id`, '');
      }
    }

    let y;
    for (y = 1; y < 4; y++) {
      if (values[`file${y}`] && !values[`file${y}`].assetId) {
        data.append(`file${y}`, values[`file${y}`]);
      } else if (values[`file${y}`] && values[`file${y}`].assetId) {
        data.append(`file${y}Id`, values[`file${y}`].assetId);
      } else {
        data.append(`file${y}Id`, '');
      }
    }

    if (values.ies === null) {
      data.append('iesId', '');
    } else if (!values.ies.assetId) {
      data.append('ies', values.ies);
    } else {
      data.append('iesId', values.ies.assetId);
    }
    let answers = Object.values(this.state.menuQuestions);
    let multipleAnswers = this.state.multipleQuestionsId;
    let generatedText = this.state.generatedTextValues;
    let textFieldAnswers = this.state.textFieldValues;

    let index = 0;

    for (let a = 0; a < answers.length; a++) {
      if (answers[a] !== 9999) {
        data.append(`answers[${index}].answerId`, answers[a]);
        index++;
      }
    }

    for (let a = 0; a < multipleAnswers.length; a++) {
      if (multipleAnswers[a] !== 9999) {
        data.append(`answers[${index}].answerId`, multipleAnswers[a]);
        if (
          multipleAnswers[a] === '10' &&
          this.state.generatedTextField === true
        ) {
          data.append(`answers[${index}].value`, generatedText[10]);
        }
        index++;
      }
    }

    for (let a = 0; a < Object.values(textFieldAnswers).length; a++) {
      if (Object.entries(textFieldAnswers)[a][1] !== '') {
        data.append(
          `answers[${index}].answerId`,
          Object.entries(textFieldAnswers)[a][0]
        );
        data.append(
          `answers[${index}].value`,
          Object.entries(textFieldAnswers)[a][1]
        );
        index++;
      }
    }

    // data.set('note', values.note);
    data.append('slipNote', note);
    this.setState(
      prevState => ({
        ...prevState,
        viewState: slipMachine.transition(prevState.viewState, 'EDIT_SLIP')
          .value,
      }),
      this.editSlip(slipId, data)
    );
  };

  onCloseNotification = () => {
    this.setState({
      showNotification: false,
    });
  };

  onDeal = () => {
    this.setState(
      prevState => ({
        ...prevState,
        viewState: slipMachine.transition(prevState.viewState, 'EDIT_SLIP')
          .value,
      }),
      () => {
        API.slipDeal(this.props.match.params.slipId).then(res => {
          this.setState(prevState => {
            return {
              ...prevState,
              slipState: 'DEAL',
              viewState: slipMachine.transition(prevState.viewState, 'EDITED')
                .value,
            };
          });
        });
      }
    ).catch(err => {
      this.setState(prevState => ({
        ...prevState,
        errors: err,
        viewState: slipMachine.transition(prevState.viewState, 'ERROR').value,
      }));
    });
  };

  renderSupplayImages = () => {
    const assets = [];
    if (this.state.photo !== null) {
      assets.push(this.state.photo);
    }
    if (this.state.photo1 !== null) {
      assets.push(this.state.photo1);
    }
    if (this.state.photo2 !== null) {
      assets.push(this.state.photo2);
    }
    return assets;
  };

  renderRestOfSlip = (
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    handleSubmit,
    setFieldValue
  ) => {
    return (
      <React.Fragment>
        {this.state.slip.shortlisted && this.renderSpecificationSheet()}
        <Grid
          container
          spacing={16}
          className={this.state.slip.shortlisted ? 'takeFreeSpace' : ''}
        >
          <Grid item xs={12} md={8}>
            <AddPhoto
              error={
                !this.state.slip.shortlisted
                  ? (errors.photo || errors.photo1 || errors.photo2) &&
                    (touched.photo || touched.photo1 || touched.photo2)
                    ? errors.photo || errors.photo1 || errors.photo2
                    : null
                  : (errors.luminaireImage ||
                      errors.polarDiagramImage ||
                      errors.dimensionsImage) &&
                    (touched.luminaireImage ||
                      touched.polarDiagramImage ||
                      touched.dimensionsImage)
                  ? errors.luminaireImage ||
                    errors.polarDiagramImage ||
                    errors.dimensionsImage
                  : null
              }
              onPhotoClear={this.onClearImage(setFieldValue)}
              photoRef={
                this.state.slip.shortlisted ? this.luminaireImage : this.photo
              }
              photo1Ref={
                this.state.slip.shortlisted
                  ? this.polarDiagramImage
                  : this.photo1
              }
              photo2Ref={
                this.state.slip.shortlisted ? this.dimensionsImage : this.photo2
              }
              photo={
                this.state.slip.shortlisted
                  ? this.state.luminaireImage
                  : this.state.photo
              }
              photo1={
                this.state.slip.shortlisted
                  ? this.state.polarDiagramImage
                  : this.state.photo1
              }
              photo2={
                this.state.slip.shortlisted
                  ? this.state.dimensionsImage
                  : this.state.photo2
              }
              onAddPhoto={this.onAddPhoto(setFieldValue)}
              isTicketExpired={
                this.props.location.state && this.props.location.state.expired
              }
              shortlisted={this.state.slip.shortlisted}
              isSlipDiscarded={
                this.state.slip.slipState === 'DISCARDED' ? true : false
              }
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <NoteAndUrl
              isUpdated={this.state.slip.updated}
              notes={this.state.slipNotes}
              notesGeneral={this.state.criteria.note}
              shortlisted={this.state.slip.shortlisted}
              noteError={
                errors.slipNote && touched.slipNote ? errors.slipNote : null
              }
              urlError={errors.url && touched.url ? errors.url : null}
              onUrlAndNoteChange={this.onUrlAndNoteChange(setFieldValue)}
              addGeneralNote={this.onAddGeneralNote(setFieldValue)}
              generalNotes={values.generalNotes}
              note={values.slipNote}
              url={values.url}
              isSlipDiscarded={
                this.state.slip.slipState === 'DISCARDED' ? true : false
              }
              details={this.state.slip.supplierContact}
            />
          </Grid>
        </Grid>
        {!this.state.slip.shortlisted && (
          <Grid container spacing={16} alignItems="stretch">
            {/* <Grid item xs={12} md={8}>
              <Grid container spacing={16} alignItems="stretch"> */}
            <Grid item xs={12} md={4}>
              <IESUpload
                error={errors.ies && touched.ies ? errors.ies : null}
                onIESFileRemove={this.onClearValue(setFieldValue, true)}
                iesInputRef={this.iesInputRef}
                ies={values.ies}
                onAddIESFile={this.onAddIESFile(setFieldValue)}
                isTicketExpired={
                  this.props.location.state && this.props.location.state.expired
                }
                // shortlisted={this.state.slip.shortlisted}
                isSlipDiscarded={
                  this.state.slip.slipState === 'DISCARDED' ? true : false
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <AddSpecifications
                isTicketExpired={
                  this.props.location.state && this.props.location.state.expired
                }
                error={
                  errors.specificationSheets && touched.specificationSheets
                    ? errors.specificationSheets
                    : null
                }
                onSpecificationRemove={this.onSpecificationRemove(
                  setFieldValue,
                  values
                )}
                onAddSpecification={this.onAddSpecification(
                  setFieldValue,
                  values
                )}
                file1={values.file1}
                file2={values.file2}
                file3={values.file3}
                specificationRef={this.specificationRef}
                // shortlisted={this.state.slip.shortlisted}
                isSlipDiscarded={
                  this.state.slip.slipState === 'DISCARDED' ? true : false
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <AddAttachment
                isTicketExpired={
                  this.props.location.state && this.props.location.state.expired
                }
                error={
                  errors.attachmentFiles && touched.attachmentFiles
                    ? errors.attachmentFiles
                    : null
                }
                onAttachmentRemove={this.onAttachmentRemove(
                  setFieldValue,
                  values
                )}
                onAddAttachment={this.onAddAttachment(setFieldValue, values)}
                attachmentFile1={values.attachmentFile1}
                attachmentFile2={values.attachmentFile2}
                attachmentFile3={values.attachmentFile3}
                attachmentFile4={values.attachmentFile4}
                attachmentFile5={values.attachmentFile5}
                attachmentFile6={values.attachmentFile6}
                attachmentFile7={values.attachmentFile7}
                attachmentRef={this.attachmentRef}
                shortlisted={false}
                isSlipDiscarded={
                  this.state.slip.slipState === 'DISCARDED' ? true : false
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <ContactDetails details={this.state.slip.supplierContact} />
            </Grid>
            {/* </Grid>
            </Grid> */}
          </Grid>
        )}
        {!this.state.slip.shortlisted && (
          <Grid container spacing={16} alignItems="stretch">
            {this.state.slip.rating ? (
              <Grid item xs={12} md={4}>
                <Rating rating={this.state.slip.rating} />
              </Grid>
            ) : null}
            {/* {this.state.slip.ratingComment ? (
              <Grid item xs={12} md={4}>
                <Comment
                  contact={this.state.slip.supplierContact.contact}
                  userImg={this.state.slip.supplierContact.imageId}
                  text={this.state.slip.ratingComment}
                />
              </Grid>
            ) : null} */}
            <Grid item xs={12} md={12}>
              <Correspondence
                shortlisted={this.state.slip.shortlisted}
                isUpdated={this.state.slip.updated}
                notes={this.state.slipNotes}
                noteError={
                  errors.slipNote && touched.slipNote ? errors.slipNote : null
                }
                onUrlAndNoteChange={this.onUrlAndNoteChange(setFieldValue)}
                note={values.slipNote}
                details={this.state.slip.supplierContact}
                slipCreator={this.state.slip.creatorInfo}
                isSlipDiscarded={
                  this.state.slip.slipState === 'DISCARDED' ? true : false
                }
              />
            </Grid>
          </Grid>
        )}
      </React.Fragment>
    );
  };

  renderQuantitiesandProjectDetails = (
    values,
    errors,
    touched,
    setFieldValue
  ) => {
    return (
      <React.Fragment>
        {this.state.slip.shortlisted ? (
          <Grid container spacing={16} alignItems="stretch">
            {this.state.slip.quantityValue && this.state.slip.quantityUnit ? (
              <Grid item xs={12} md={4}>
                <Quantities
                  quantities={this.state.slip.quantityValue}
                  unit={this.state.slip.quantityUnit}
                />
              </Grid>
            ) : null}

            <Grid item xs={12} md={4}>
              <ProjectDetails
                data={this.state.slip.projectDetails}
                arupData={this.state.slip.demandContact}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <AddQuotation
                onAddQuotation={this.onAddQuotation(setFieldValue)}
                onRemoveQuotation={this.onClearValue(setFieldValue)}
                quotation={values.quotation}
                isTicketExpired={
                  this.props.location.state && this.props.location.state.expired
                }
                error={
                  errors.quotation && touched.quotation
                    ? errors.quotation
                    : null
                }
                isSlipDiscarded={
                  this.state.slip.slipState === 'DISCARDED' ? true : false
                }
              />
            </Grid>

            {!this.state.slip.shortlisted && (
              <Grid item xs={12} md={4}>
                <ContactDetails details={this.state.slip.supplierContact} />
              </Grid>
            )}

            {this.state.slip.deal && (
              <Grid item xs={12}>
                <DealSection
                  isDeal={this.state.slipState}
                  onDeal={this.onDeal}
                />
              </Grid>
            )}
          </Grid>
        ) : null}
      </React.Fragment>
    );
  };

  onFileSizeErrorCancel = () => {
    this.setState(state => ({
      ...state,
      viewState: slipMachine.transition(state.viewState, 'CANCEL').value,
    }));
  };

  submitAndValidate = (useValidation, cb, indicator) => () => {
    var open = false;
    if (
      (this.state.slip.slipState === 'VIEWED' ||
        this.state.slip.slipState === 'RESPONDED' ||
        this.state.slip.slipState === 'DEAL') &&
      this.state.slip.shortlisted
    ) {
      if (
        (indicator === 'publish' && this.state.slip.drafted) ||
        (indicator === 'update' && !this.state.slip.drafted)
      ) {
        if (
          !this.state.luminaireImage ||
          !this.state.dimensionsImage ||
          !this.state.polarDiagramImage ||
          !this.state.quotationAdded
        ) {
          open = true;
        }
      }
    }

    this.setState({ validateSpecSheet: useValidation, open }, cb);
  };

  disableSubmitIfIsDeactivated = () => {
    return this.state.slip.attentionText ===
      'This project has been deactivated permanently, thus you cannot respond to this slip anymore'
      ? true
      : false;
  };

  handleCloseSnack = () => {
    this.setState({ open: false });
  };

  render() {
    if (this.state.slip) {
      const values = this.makeInitialValues(this.state.criteria);
      return (
        <React.Fragment>
          <Formik
            initialValues={values}
            onSubmit={
              this.state.slip.shortlisted
                ? this.onSpecificationFormSave
                : this.onEditSlip
            }
            validationSchema={makeSchema(
              values,
              this.state.slip.shortlisted,
              !this.state.validateSpecSheet
            )}
            enableReinitialize={true}
          >
            {({
              values,
              handleChange,
              handleBlur,
              errors,
              touched,
              handleSubmit,
              setFieldValue,
            }) => {
              if (this.state.viewState === 'loading') {
                return (
                  <Container>
                    <Loader isLoading />
                  </Container>
                );
              }
              return (
                <Container>
                  {this.state.viewState === 'error' && (
                    <Error
                      onCancel={this.onErrorCancel}
                      onRetry={this.onRetry}
                      errors={this.state.errors}
                    />
                  )}
                  <ErrorNotification
                    message={
                      this.state.viewState === 'photo_size_error'
                        ? 'Image size cannot be greater then 5 MB'
                        : this.state.viewState === 'ies_size_error'
                        ? 'File size cannot be greater then 5 MB'
                        : this.state.viewState === 'spec_size_error'
                        ? 'Specifications files size cannot be greater then 5 MB'
                        : this.state.viewState === 'attach_size_error'
                        ? 'Attachment files size cannot be greater then 5 MB'
                        : null
                    }
                    open={
                      this.state.viewState &&
                      this.state.viewState.includes('size_error')
                    }
                    onCancel={this.onFileSizeErrorCancel}
                  />
                  <Success
                    open={this.state.showNotification}
                    message="Slip is successfully edited!"
                    handleClose={this.onCloseNotification}
                  />

                  <HeaderGrid container justify="space-between">
                    {this.state.slip.attentionText && (
                      <UpdateMsg>{this.state.slip.attentionText}</UpdateMsg>
                    )}

                    <Grid item>
                      <TicketReference
                        name={this.state.criteria.ticketReferenceName}
                        iconCombination={this.state.criteria.ticketImageName}
                        locationOnPlan={this.state.locationOnPlan}
                        projectInfo={this.state.projectInfo}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <CountryProject
                        country={
                          this.state.projectCountry && this.state.projectCountry
                        }
                        projectName={
                          this.state.projectName && this.state.projectName
                        }
                      />
                    </Grid>
                    <Grid item>
                      <IssuedBy
                        name={this.state.criteria.supplierContact.contact}
                        date={this.state.criteria.creatorInfo.dateCreated}
                      />
                    </Grid>
                  </HeaderGrid>

                  {this.renderCriteria(
                    handleChange,
                    handleBlur,
                    values,
                    errors,
                    touched
                  )}

                  {this.state.slip.shortlisted ? (
                    <PhotosAndNotes
                      assets={this.renderSupplayImages()}
                      // note={this.state.criteria.note}
                      shortlisted={this.state.slip.shortlisted}
                    />
                  ) : (
                    <PhotosAndNotes
                      assets={this.state.criteria.assets}
                      note={this.state.criteria.note}
                    />
                  )}

                  {this.state.slip.shortlisted && (
                    <Grid container spacing={16} alignItems="stretch">
                      <Grid item xs={12} md={12}>
                        <Grid container spacing={16} alignItems="stretch">
                          <Grid item xs={12} md={4}>
                            <IESUpload
                              error={
                                errors.ies && touched.ies ? errors.ies : null
                              }
                              onIESFileRemove={this.onClearValue(
                                setFieldValue,
                                true
                              )}
                              iesInputRef={this.iesInputRef}
                              ies={values.ies}
                              onAddIESFile={this.onAddIESFile(setFieldValue)}
                              isTicketExpired={
                                this.props.location.state &&
                                this.props.location.state.expired
                              }
                              isSlipDiscarded={
                                this.state.slip.slipState === 'DISCARDED'
                                  ? true
                                  : false
                              }
                            />
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <AddSpecifications
                              isTicketExpired={
                                this.props.location.state &&
                                this.props.location.state.expired
                              }
                              error={
                                errors.specificationSheets &&
                                touched.specificationSheets
                                  ? errors.specificationSheets
                                  : null
                              }
                              onSpecificationRemove={this.onSpecificationRemove(
                                setFieldValue,
                                values
                              )}
                              onAddSpecification={this.onAddSpecification(
                                setFieldValue,
                                values
                              )}
                              file1={values.file1}
                              file2={values.file2}
                              file3={values.file3}
                              specificationRef={this.specificationRef}
                              isSlipDiscarded={
                                this.state.slip.slipState === 'DISCARDED'
                                  ? true
                                  : false
                              }
                            />
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <AddAttachment
                              isTicketExpired={
                                this.props.location.state &&
                                this.props.location.state.expired
                              }
                              error={
                                errors.attachmentFiles &&
                                touched.attachmentFiles
                                  ? errors.attachmentFiles
                                  : null
                              }
                              onAttachmentRemove={this.onAttachmentRemove(
                                setFieldValue,
                                values
                              )}
                              onAddAttachment={this.onAddAttachment(
                                setFieldValue,
                                values
                              )}
                              attachmentFile1={values.attachmentFile1}
                              attachmentFile2={values.attachmentFile2}
                              attachmentFile3={values.attachmentFile3}
                              attachmentFile4={values.attachmentFile4}
                              attachmentFile5={values.attachmentFile5}
                              attachmentFile6={values.attachmentFile6}
                              attachmentFile7={values.attachmentFile7}
                              attachmentRef={this.attachmentRef}
                              shortlisted={false}
                              isSlipDiscarded={
                                this.state.slip.slipState === 'DISCARDED'
                                  ? true
                                  : false
                              }
                            />
                          </Grid>
                          <GridUrl item xs={12} md={4}>
                            <Url url={values.url} />
                          </GridUrl>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  {this.state.slip.shortlisted ? (
                    <Grid>
                      {this.state.shortlistedCircularEconomy.length !== 0 && (
                        <div>
                          <h2 className="t-primary-16 t-weight-b u-mrg-bot-3 u-mrg-top-20">
                            Circular Economy Assessment
                          </h2>
                        </div>
                      )}
                      {this.state.shortlistedCircularEconomy &&
                        this.state.shortlistedCircularEconomy.map(group => (
                          <Grid item className="u-pad-bot-30">
                            <Grid
                              item
                              className="t-primary-15 t-weight-b u-mrg-bot-3 u-mrg-top-20"
                            >
                              <em>{group.text}</em>
                            </Grid>
                            {group.questions.map(question => (
                              <Grid container>
                                <Grid className="t-primary-13 t-weight-b u-mrg-bot-3 u-mrg-top-20 w50">
                                  {question.text}
                                </Grid>
                                {question.questionType === 'PULL_DOWN_MENU' && (
                                  <Grid
                                    item
                                    className="c-gray-light t-primary-13 u-mrg-left-100 u-mrg-top-10 menuItem"
                                  >
                                    <div className="u-mrg-bot-5">
                                      {question.answers.map(
                                        answer => answer.text
                                      )}
                                    </div>
                                  </Grid>
                                )}
                                {question.questionType ===
                                  'PULL_DOWN_MENU_MULTISELECT' && (
                                  <Grid
                                    item
                                    className="c-gray-light t-primary-13 u-mrg-left-100 u-mrg-top-10 menuItem"
                                  >
                                    {question.answers.map(answer => (
                                      <div className="u-mrg-bot-5">
                                        {answer.text}
                                        {answer.answerValue && (
                                          <p>
                                            <TextField
                                              multiline
                                              fullWidth
                                              rowsMax={5}
                                              className="autoHeightComponent"
                                              disabled
                                              value={answer.answerValue}
                                            />
                                          </p>
                                        )}
                                      </div>
                                    ))}
                                  </Grid>
                                )}
                                {question.questionType === 'DIRECT' && (
                                  <Grid
                                    item
                                    className="c-gray-light t-primary-13 u-mrg-left-100 u-mrg-top-10 menuItem"
                                  >
                                    {question.answers.map(answer => (
                                      <div className="u-mrg-bot-5">
                                        {answer.text}
                                        {answer.answerValue && (
                                          <div>
                                            <TextField
                                              multiline
                                              fullWidth
                                              rowsMax={5}
                                              className="autoHeightComponent"
                                              disabled
                                              value={answer.answerValue}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                  </Grid>
                                )}
                              </Grid>
                            ))}
                          </Grid>
                        ))}
                      <Divider className="u-mrg-top-5 u-mrg-bot-5" />
                    </Grid>
                  ) : (
                    <Grid>
                      {this.state.circularEconomy.length !== 0 && (
                        <div>
                          <h2 className="t-primary-16 t-weight-b u-mrg-bot-3 u-mrg-top-20">
                            Circular Economy Assessment
                          </h2>
                          <p className="t-primary-13 t-weight-b u-mrg-bot-3 c-red">
                            The specifier has required the following questions
                            to be answered with your response - response cannot
                            be submitted without answering these questions.
                          </p>
                        </div>
                      )}
                      {this.state.circularEconomy &&
                        this.state.circularEconomy.map(item => (
                          <Grid item className="u-pad-bot-30">
                            <Grid
                              item
                              className="t-primary-15 t-weight-b u-mrg-bot-3 u-mrg-top-20"
                            >
                              <em>{item.text}</em>
                            </Grid>
                            <Grid item>
                              {item.questions.map(question => (
                                <Grid container>
                                  <Grid className="t-primary-13 t-weight-b u-mrg-bot-3 u-mrg-top-20 w50">
                                    {question.text}
                                  </Grid>
                                  <Grid className="t-primary-13 u-mrg-left-100 u-mrg-top-10">
                                    {question.questionType ===
                                      'PULL_DOWN_MENU' && (
                                      <SelectCustom
                                        className="menuItem"
                                        disableUnderline={true}
                                        value={
                                          this.state.menuQuestions[question.id]
                                        }
                                        onChange={event =>
                                          this.handleQuestions(
                                            event,
                                            question.id,
                                            'singleSelect'
                                          )
                                        }
                                        variant="outlined"
                                        defaultValue={
                                          this.state.menuQuestions[question.id]
                                        }
                                      >
                                        <MenuItem
                                          disabled
                                          className="menuItem"
                                          value={9999}
                                        >
                                          Not Set
                                        </MenuItem>
                                        {question.answers.map(answer => (
                                          <MenuItem
                                            className="menuItem"
                                            value={answer.id}
                                          >
                                            {answer.text}
                                          </MenuItem>
                                        ))}
                                      </SelectCustom>
                                    )}
                                    {question.questionType ===
                                      'PULL_DOWN_MENU_MULTISELECT' && (
                                      <div>
                                        <SelectCustom
                                          className="menuItem"
                                          style={{ maxWidth: '325px' }}
                                          multiple
                                          displayEmpty
                                          disableUnderline={true}
                                          value={Object.values(
                                            this.state.multipleQuestions[
                                              question.id
                                            ]
                                          )}
                                          name={question.id}
                                          onChange={event =>
                                            this.handleQuestions(
                                              event,
                                              question.id,
                                              'multipleSelect',
                                              event.currentTarget.getAttribute(
                                                'data-type'
                                              ),
                                              event.currentTarget.getAttribute(
                                                'data-id'
                                              )
                                            )
                                          }
                                          inputProps={{
                                            'aria-label': 'Without label',
                                          }}
                                          // input={<Input />}
                                          variant="outlined"
                                          renderValue={selected => {
                                            if (selected.length === 0) {
                                              return <p>Not Set</p>;
                                            }

                                            return selected.join(', ');
                                          }}
                                        >
                                          <MenuItem
                                            disabled
                                            className="menuItem"
                                            value={9999}
                                            data-name={'9999'}
                                          >
                                            Not Set
                                          </MenuItem>
                                          {question.answers.map(answer => (
                                            <MenuItem
                                              className="menuItem"
                                              key={answer.id}
                                              value={answer.text}
                                              data-type={answer.answerType}
                                              data-id={answer.id}
                                            >
                                              {answer.text}
                                            </MenuItem>
                                          ))}
                                        </SelectCustom>
                                        {this.state.generatedTextField && (
                                          <div>
                                            <TextField
                                              className="autoHeightComponent"
                                              multiline
                                              value={
                                                this.state
                                                  .generatedTextValues[10]
                                              }
                                              onChange={event =>
                                                this.handleGeneratedTextField(
                                                  event,
                                                  10
                                                )
                                              }
                                            />
                                          </div>
                                        )}
                                      </div>
                                    )}
                                    {question.questionType === 'DIRECT' &&
                                      question.answers.map(answer => (
                                        <Grid item>
                                          <TextField
                                            className="menuItem"
                                            multiline
                                            label={answer.text}
                                            value={
                                              this.state.textFieldValues[
                                                answer.id
                                              ]
                                            }
                                            onChange={event =>
                                              this.handleTextField(
                                                event,
                                                answer.id
                                              )
                                            }
                                          />
                                        </Grid>
                                      ))}
                                  </Grid>
                                </Grid>
                              ))}
                            </Grid>
                          </Grid>
                        ))}
                      <Divider className="u-mrg-top-10 u-mrg-bot-10" />
                    </Grid>
                  )}
                  {this.state.slip.shortlisted ? (
                    <React.Fragment>
                      <PaperSheet elevation={5}>
                        {this.renderRestOfSlip(
                          values,
                          handleChange,
                          handleBlur,
                          errors,
                          touched,
                          handleSubmit,
                          setFieldValue
                        )}
                      </PaperSheet>
                      {this.renderQuantitiesandProjectDetails(
                        values,
                        errors,
                        touched,
                        setFieldValue
                      )}
                      <Grid item xs={12} md={12}>
                        <Correspondence
                          isUpdated={this.state.slip.updated}
                          notes={this.state.slipNotes}
                          notesGeneral={this.state.criteria.note}
                          shortlisted={this.state.slip.shortlisted}
                          noteError={
                            errors.slipNote && touched.slipNote
                              ? errors.slipNote
                              : null
                          }
                          urlError={
                            errors.url && touched.url ? errors.url : null
                          }
                          onUrlAndNoteChange={this.onUrlAndNoteChange(
                            setFieldValue
                          )}
                          note={values.slipNote}
                          url={values.url}
                          isTicketExpired={
                            this.props.location.state &&
                            this.props.location.state.expired
                          }
                          details={this.state.slip.supplierContact}
                          slipCreator={this.state.slip.creatorInfo}
                          isSlipDiscarded={
                            this.state.slip.slipState === 'DISCARDED'
                              ? true
                              : false
                          }
                        />
                      </Grid>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {this.renderRestOfSlip(
                        values,
                        handleChange,
                        handleBlur,
                        errors,
                        touched,
                        handleSubmit,
                        setFieldValue
                      )}
                      {this.renderQuantitiesandProjectDetails(
                        values,
                        errors,
                        touched,
                        setFieldValue
                      )}
                    </React.Fragment>
                  )}

                  <Grid container spacing={8}>
                    {/* commented out for now on client request */}
                    {/* {this.state.slip.showButton && (
                      <Grid item sm={6} xs={12}>
                        <SlipActionButton
                          onClick={this.submitAndValidate(
                            this.state.slip.drafted ? true : false,
                            handleSubmit,
                            this.state.slip.drafted ? 'publish' : 'draft'
                          )}
                          variant="contained"
                          color="primary"
                          fullWidth
                          disabled={
                            this.state.slip.slipState === 'DISCARDED'
                              ? true
                              : false || this.disableSubmitIfIsDeactivated()
                          }
                        >
                          {this.state.slip.drafted ? 'Publish' : 'Save Draft'}
                        </SlipActionButton>
                      </Grid>
                    )} */}
                    <Grid item sm={6} xs={12}>
                      <SlipActionButton
                        onClick={this.submitAndValidate(
                          this.state.slip.drafted ? false : true,
                          handleSubmit,
                          'update'
                        )}
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={
                          this.state.slip.slipState === 'DISCARDED'
                            ? true
                            : false || this.disableSubmitIfIsDeactivated()
                        }
                      >
                        Update Response
                      </SlipActionButton>
                    </Grid>
                  </Grid>
                </Container>
              );
            }}
          </Formik>
          <Snackbar
            open={this.state.open}
            message={
              'Error - not submitted. Please ensure you have completed all information on the Luminaire Specification Sheet and have uploaded budget pricing before issuing your response.'
            }
            onClose={this.handleCloseSnack}
          />
        </React.Fragment>
      );
    }

    return (
      <Container>
        <Loader isLoading />
      </Container>
    );
  }
}

export default withSpecSheet(TicketView);
